import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const i = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 314 314", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_21875_91937)", children: [
    /* @__PURE__ */ s.jsx("rect", { width: "313.043", height: "313.043", rx: "156.522", fill: "black" }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M313.043 156.522C313.043 242.966 242.966 313.043 156.522 313.043C70.0772 313.043 0 242.966 0 156.522C0 70.0772 70.0772 0 156.522 0C242.966 0 313.043 70.0772 313.043 156.522Z",
        fill: "#424242"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M296.086 156.423C296.086 233.557 233.557 296.086 156.423 296.086C79.2898 296.086 16.7607 233.557 16.7607 156.423C16.7607 79.2898 79.2898 16.7607 156.423 16.7607C233.557 16.7607 296.086 79.2898 296.086 156.423Z",
        fill: "url(#paint0_linear_21875_91937)"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M146.203 57.488L70.1332 194.403L166.864 151.318L146.203 57.488Z",
        fill: "url(#paint1_linear_21875_91937)"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M209.124 133.126L160.29 46.9561L180.951 145.573L209.124 133.126Z",
        fill: "url(#paint2_linear_21875_91937)"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M217.577 147.488L183.768 163.765L196.916 226.956H262.655L217.577 147.488Z",
        fill: "url(#paint3_linear_21875_91937)"
      }
    ),
    /* @__PURE__ */ s.jsx("path", { d: "M181.89 226.956L170.62 169.509L51.3506 226.956H181.89Z", fill: "url(#paint4_linear_21875_91937)" })
  ] }),
  /* @__PURE__ */ s.jsx(
    "rect",
    {
      x: "8.86809",
      y: "8.86809",
      width: "295.307",
      height: "295.307",
      rx: "147.654",
      stroke: "url(#paint5_linear_21875_91937)",
      strokeWidth: "17.7362"
    }
  ),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint0_linear_21875_91937",
        x1: "156.423",
        y1: "16.7607",
        x2: "156.423",
        y2: "296.086",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "white" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "white" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint1_linear_21875_91937",
        x1: "87.6585",
        y1: "-7.81413",
        x2: "275.919",
        y2: "6.04756",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#8F8FEF" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#5939FF" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint2_linear_21875_91937",
        x1: "87.6585",
        y1: "-7.81413",
        x2: "275.919",
        y2: "6.04756",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#8F8FEF" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#5939FF" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint3_linear_21875_91937",
        x1: "87.6585",
        y1: "-7.81413",
        x2: "275.919",
        y2: "6.04756",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#8F8FEF" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#5939FF" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint4_linear_21875_91937",
        x1: "87.6585",
        y1: "-7.81413",
        x2: "275.919",
        y2: "6.04756",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#8F8FEF" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#5939FF" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint5_linear_21875_91937",
        x1: "8.58197",
        y1: "276.533",
        x2: "274.328",
        y2: "276.533",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#AAFBB8" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.494999", stopColor: "#4520FF" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#FF49D9" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_21875_91937", children: /* @__PURE__ */ s.jsx("rect", { width: "313.043", height: "313.043", rx: "156.522", fill: "white" }) })
  ] })
] });
export {
  i as X
};
